import styled from 'styled-components';

export const Component = styled.div`
  position: absolute;
  top: 50%;
  left: var(--value, 0);
  right: 0;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;
  pointer-events: none;
`;
